import DiscussionsModel from '../Apis/Discussions'
import Controller from './Controller'

export default class DiscussionsController extends Controller {
  constructor() {
    super(new DiscussionsModel())
  }
}
